module.exports = __webpack_public_path__ + "img/banner_gme.92415bea.png";